import styled from 'styled-components';
export const Header = styled.div`
  display: grid;
  grid-template-columns: minmax(500px, 1fr) auto minmax(0, 1fr);
  align-items: ${({ customStyle }) => customStyle ? 'flex-start' : 'center'};
  grid-row: 1/2;
  padding:${({ customPadding }) => customPadding ? '20px 20px 10px 20px' : '20px 20px 24px 20px'};
`;
Header.displayName = 'Header';

export const LeftZone = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
`;
LeftZone.displayName = 'LeftZone';

export const CenterZone = styled.div`
  display: flex;
  align-items: center;
  justify-self: center;
`;
CenterZone.displayName = 'CenterZone';

export const RightZone = styled.div`
  display: flex;
  align-items: center;
  justify-self: end;
`;
RightZone.displayName = 'RightZone';

export const Separator = styled.div`
  height: 16px;
  border-left: solid 1px ${({ theme }) => theme.text.vulnsCounter};
  transform: rotate(22deg);
  margin-right: 9px;
`;
Separator.displayName = 'Separator';
